"use client";

import { makeStore, type AppStore } from "@/store";

declare global {
  interface Window {
    __petromin_redux_store__?: AppStore;
  }
}

/** One store per browser tab so Strict Mode remounts do not reset analytics state. */
export function getClientSingletonStore(): AppStore {
  if (typeof window === "undefined") {
    return makeStore();
  }
  if (!window.__petromin_redux_store__) {
    window.__petromin_redux_store__ = makeStore();
  }
  return window.__petromin_redux_store__;
}
